import React, {useEffect, useRef, useState} from "react";
import AccordionSummary from "@mui/material/AccordionSummary";
import surveyheart1 from "../../../public/images/surveyheart1.png";
import right_path_arrow from "../../../public/images/right_path_arrow.svg";
import arrow_back_black from "../../../public/images/arrow_back_black.svg";
import Vector from "../../../public/images/Vector.png";
import {Provider} from "react-redux";
import newAdminStore from "../../admin/store/newAdminStore";
import {useLocation} from "react-router-dom";
import ImageViewerComponent from "../../form/components/questions/ImageViewerComponent";
import MaterialButton, {ButtonTypes} from "../../shared/components/MaterialButton";
import search_grey from '../../../public/images/search_grey.svg';
import details from '../../../public/images/details.svg';
import share_grey from '../../../public/images/share_grey.svg';
import link from '../../../public/images/link.svg'
import SearchBaseComponent from "../../admin/components/SearchBaseComponent";
import '../css/faq.css';
import {allCategories, categoryFaqs, searchFaqs, FaqsDetailedAnswer} from "../../shared/utils/sash-v2-api";
import {PAGE_HASH_LOCATION} from "../../app/utils/pages";
import {ADMIN_FORM_IDS} from "../../admin/constants";

const FaqMobileView = () => {

    const [selectedCategory, setSelectedCategory] = useState(null);
    const [selectedQuestion, setSelectedQuestion] = useState(null);
    const [accordionData, setAccordionData] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [showVideo, setShowVideo] = useState(false);
    const [showDetailsOptions, setShowDetailsOptions] = useState(false);
    const location = useLocation();
    const [copyStatus, setCopyStatus] = useState("Copy Link");
    const [searchResults, setSearchResults] = useState([]);
    const debounceTimerRef = useRef(null);
    const [isSearchSubmitted, setIsSearchSubmitted] = useState(false);


    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const idFromURL = queryParams.get("id");
        if (idFromURL) {
            const fetchDetailedAnswer = () => {
                const FAQDetailedSuccess = (response) => {
                    if (response.faq._id === idFromURL) {
                        setSelectedQuestion(response.faq);
                    }
                };
                const FAQDetailedFailure = (error) => {
                    console.error(error);
                };
                FaqsDetailedAnswer(idFromURL, FAQDetailedSuccess, FAQDetailedFailure,);
            };
            fetchDetailedAnswer();

        } else {
            setSelectedQuestion(null);
        }
    }, [location.search]);

    const handleFetchSuccess = (data) => {
        if (Array.isArray(data.all_Categories)) {
            const initialAccordionData = data.all_Categories.map(category => ({
                ...category, questions: []
            }));
            setAccordionData(initialAccordionData);
        } else {
            console.error(data.all_Categories);
        }
    };
    const handleFetchFailure = (err) => {
        console.error("Failed", err);
    };

    useEffect(() => {
        const fetchCategories = () => {
            allCategories({}, (data) => handleFetchSuccess(data), (error) => handleFetchFailure(error));
        };
        fetchCategories();
    }, []);


    const handleQuestionClick = (question) => {
        setSelectedQuestion(question)
        setSearchText("");
        window.location.href = PAGE_HASH_LOCATION.faq + `?id=${question._id}`;
    };

    const handleBackToFAQ = () => {
        if (selectedQuestion) {
            window.location.href = PAGE_HASH_LOCATION.faq
            setSelectedQuestion(null);
        } else if (selectedCategory) {
            setSelectedCategory(null);
            window.location.href = PAGE_HASH_LOCATION.faq
        } else {
            window.location.href = window.location.origin;
        }
    };

    const handleSearchChange = (search) => {
        setSearchText(search);
        setIsSearchSubmitted(true);

        if (debounceTimerRef.current) {
            clearTimeout(debounceTimerRef.current);
        }
        if (search.length > 0) {
            const timer = setTimeout(() => {
                fetchSearchResults(search);
            }, 1000);

            debounceTimerRef.current = timer;
        } else {
            setSearchResults([]);
            setIsSearchSubmitted(false);
        }
    };

    const fetchSearchResults = (searchString) => {
        if (searchString) {
            const successFunction = (response) => {
                if (response?.result === "SUCCESS") {
                    if (response.all_faqs && Array.isArray(response.all_faqs)) {
                        setSearchResults(response.all_faqs);
                    }
                } else {
                    setSearchResults([]);
                }
            };
            const failureFunction = (error) => {
                console.log(error)
            };
            searchFaqs({keyword: searchString}, successFunction, failureFunction);
        } else {
            setSearchResults([]);
            setIsSearchSubmitted(false);
        }
    };

    const filteredQuestions = accordionData.reduce((acc, section) => {
        if (section.questions) {
            const matches = section.questions.filter(q => q.question.toLowerCase().includes(searchText.toLowerCase()));
            if (matches.length > 0) {
                acc.push(...matches);
            }
        }
        return acc;
    }, []);

    const handleCopyLink = () => {
        if (selectedQuestion) {
            const link = `${window.location.origin}${window.location.pathname}#faq?id=${selectedQuestion._id}`;
            navigator.clipboard.writeText(link);
            setCopyStatus("Link Copied");
            setTimeout(() => setCopyStatus("Copy Link"), 2000);
        }
    };

    const handleShare = () => {
        if (selectedQuestion) {
            const questionUrl = `${window.location.origin}${window.location.pathname}#faq?id=${selectedQuestion._id}`;
            if (navigator.share) {
                navigator.share({
                    title: selectedQuestion.question, url: questionUrl,
                });
            }
        }

    };
    const handleCategoryClick = (category) => {
        setSelectedCategory(category);
        const fetchCategoryFaqs = () => {
            const categoryFaqsSuccess = (response) => {
                if (response?.result === "SUCCESS") {
                    if (response.faqs && Array.isArray(response.faqs)) {
                        setSelectedCategory(prevCategory => ({
                            ...prevCategory, questions: response.faqs,
                        }));
                    } else {
                        setSelectedCategory(prevCategory => ({
                            ...prevCategory, questions: [],
                        }));
                    }
                }
            };
            const categoryFaqsFailure = (error) => {
                console.log(error);
            };
            categoryFaqs(category.category_name, {}, categoryFaqsSuccess, categoryFaqsFailure, {
            });
        };
        fetchCategoryFaqs();
    }
    const capitalizeWords = (str) => {
        return str.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
    };

    const capitalizeFirstLetter = (text) => {
        return text.charAt(0).toUpperCase() + text.slice(1);
    }

    return (<div className={'faq-mobile-view'}>
        <div>
            <div className={'titleBanner'}>
                <img className={'logo'} src={surveyheart1} alt="surveyheart-logo"/>
            </div>

            <img className={'back-arrow'}
                 src={arrow_back_black}
                 alt="Back Arrow"
                 onClick={handleBackToFAQ}
            />
            {!selectedQuestion && !selectedCategory && (
                <div className={`search-category ${searchText ? 'active' : ''}`}>
                        <SearchBaseComponent
                            width={"358px"}
                            height={"40px"}
                            handleTextChange={handleSearchChange}
                        />
                </div>)}
            {searchText && searchResults.length === 0 && isSearchSubmitted && (<div className={'no-search'}>
                <img src={search_grey} alt={"search_grey"}/>
                <br/>
                No Results Found
            </div>)}
            {!selectedQuestion && searchText && searchResults.length > 0 && (<div className={'filter-question-Content'}>
                {searchResults.map((question, index) => (<div style={{height: "49px"}} key={question._id}>
                    <div onClick={() => handleQuestionClick(question)}>
                        <AccordionSummary
                            className={'accordionHead'}
                            aria-controls={`panel${question._id}-content`}
                            id={`panel${question._id}-header`}
                        >
                            <img className={'vector-Icon'} src={Vector} alt="vector-icon"
                                 style={{marginRight: "20px"}}/>
                            <span className={'question-Text'}>{question.question}</span>
                            <img
                                src={right_path_arrow}
                                alt="right-arrow-icon"
                                className={'right-arrow-Icon'}
                            />
                        </AccordionSummary>
                    </div>

                    {index !== searchResults.length - 1 && (
                        <div style={{height: "1px", backgroundColor: "#ccc", margin: "0 16px",}}
                        />)}
                </div>))}
            </div>)}
            {!selectedQuestion && !searchText && !selectedCategory && (<div>
                <h2 className={'FAQ'}>Frequently Asked Questions</h2>
                <h1 className={'topic'}>Topics</h1>
                <div className={'category-Content'}>
                    {accordionData.map((item, index) => (<div key={index}>
                        <div className={'category-list'}
                             onClick={() => handleCategoryClick(item)}>
                            <span>{capitalizeWords(item.category_name)}</span>
                            <img src={right_path_arrow} alt="arrow-icon"/>
                        </div>

                        {index !== accordionData.length - 1 && (
                            <div style={{height: "1px", backgroundColor: "#ccc", margin: "0 16px",}}/>)}
                    </div>))}
                </div>
            </div>)}
            {selectedCategory && !selectedQuestion && (<div className={'category-View'}>
                <h2>{capitalizeFirstLetter(selectedCategory.category_name)}</h2>
                <div className={'question-Content'}>
                    {selectedCategory?.questions?.map((question, index) => (
                        <div style={{height: "49px"}} key={question._id}>
                            <div
                                onClick={() => handleQuestionClick(question)}
                            >
                                <AccordionSummary className={'accordionHead'}
                                                  aria-controls={`panel${question._id}-content`}
                                                  id={`panel${question._id}-header`}>
                                    <img className={'vector-Icon'} src={Vector} alt="vector-icon"
                                         style={{marginRight: "20px"}}/>
                                    <span className={'question-Text'}>{capitalizeFirstLetter(question.question)}</span>
                                    <img src={right_path_arrow} alt="right-arrow-icon" className={'right-arrow-Icon'}/>
                                </AccordionSummary>
                            </div>
                            {index !== selectedCategory?.questions?.length - 1 && (
                                <div style={{height: "1px", backgroundColor: "#ccc", margin: "0 16px",}}/>)}
                        </div>))}
                </div>
            </div>)}

            {selectedQuestion && (<div className="questionDetails">
                <h3 className={'question-title'}>{capitalizeFirstLetter(selectedQuestion.question)}</h3>
                <img className={'details-icon'}
                     src={details}
                     alt="details-icon" onClick={() => setShowDetailsOptions(prev => !prev)}/>
                {showDetailsOptions && (<div className={'details-Options-Popup'}>
                    <MaterialButton
                        handleClick={handleShare}
                        data={{
                            title: "Share", buttonType: ButtonTypes.OUTLINED, customButtonContainerStyle: {
                                color: 'black',
                                fontSize: '16px',
                                fontWeight: '400',
                                lineHeight: '21px',
                                letterSpacing: '0.16px',
                                height: '42px',
                                width: '129px',
                                display: 'flex',
                                gap: '8px',
                                alignItems: 'center',
                                justifyContent: 'flex-start',
                                borderBottom: '0.5px solid #ccc',
                                boxShadow: 'none',
                                backgroundColor: 'transparent',
                            }, imageFileName: 'share_grey.svg', customImageStyle: {
                                width: '14px', height: '16px',
                            },
                        }}
                    >
                        <img src={share_grey} alt="share"/>
                        Share
                    </MaterialButton>

                    <MaterialButton
                        handleClick={handleCopyLink}
                        data={{
                            title: "Copy Link", buttonType: ButtonTypes.OUTLINED, customButtonContainerStyle: {
                                borderRadius: '50px',
                                padding: '9px 12px',
                                color: 'black',
                                display: 'flex',
                                justifyContent: 'flex-start',
                                fontSize: '16px',
                                fontWeight: '400',
                                lineHeight: '21px',
                                letterSpacing: '0.16px',
                                backgroundColor: 'transparent',
                            }, imageFileName: 'link.svg', customImageStyle: {
                                width: '16px', height: '18px', marginRight: '8px',
                            },
                        }}>
                        <img src={link} alt="link"/>
                        {copyStatus}
                    </MaterialButton>
                </div>)}

                {selectedQuestion.video_url && (<div className="video-container">
                    <div className={'video-overlay'} onClick={() => setShowVideo(true)}>
                        <div className="iframe-overlay"/>
                        <iframe
                            width="370"
                            height="230"
                            src={selectedQuestion.video_url.includes('youtu.be/') ? `${selectedQuestion.video_url.replace('youtu.be/', 'www.youtube.com/embed/').split('?')[0]}` : selectedQuestion.video_url.includes('www.youtube.com/watch?v=') ? `${selectedQuestion.video_url.replace('watch?v=', 'embed/').split('&')[0]}` : ''}
                            title="YouTube video player"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            referrerPolicy="strict-origin-when-cross-origin"
                            allowFullScreen
                        />
                    </div>

                    {showVideo && (<Provider store={newAdminStore}>
                        <ImageViewerComponent
                            attachment={selectedQuestion.video_url.includes('youtu.be/') ? `${selectedQuestion.video_url.replace('youtu.be/', 'www.youtube.com/embed/').split('?')[0]}` : selectedQuestion.video_url.includes('www.youtube.com/watch?v=') ? `${selectedQuestion.video_url.replace('watch?v=', 'embed/').split('&')[0]}` : ''}
                            video={true}
                            close={() => setShowVideo(false)}
                        />
                    </Provider>)}
                </div>)}

                <div className={'question-steps'}>
                    {['android_steps', 'web_steps', 'ios_steps'].map((deviceKey) => {
                        const deviceName = deviceKey.split('_')[0];
                        return (<React.Fragment key={deviceKey}>
                            <h3 className="device">{deviceName.charAt(0).toUpperCase() + deviceName.slice(1)}</h3>
                            <ol className="step-list">
                                {selectedQuestion.answer[deviceKey] ? (selectedQuestion.answer[deviceKey].map((step, index) => (
                                    <li key={index}>{step}</li>))) : (<li>No steps available for {deviceName}</li>)}
                            </ol>
                        </React.Fragment>);
                    })}
                </div>
            </div>)}
            {(!searchText || filteredQuestions.length === 0) && !selectedQuestion && (
                <div className={'sticky-Button-Container'}>
                    {!(searchText && filteredQuestions.length === 0) && (<MaterialButton
                        data={{
                            title: "Contact Us",
                            buttonType: ButtonTypes.CONTAINED,
                            bg_color: 'rgba(0, 75, 160, 1)',
                            fontSize: '14px',
                            customButtonContainerStyle: {
                                borderRadius: '50px', padding: '9px 12px',
                            },
                            imageFileName: 'contactus.svg',
                            customImageStyle: {
                                width: '20px', marginRight: '8px',
                            },
                        }}
                        handleClick={() =>
                            window.open(`https://surveyheart.com/form/${ADMIN_FORM_IDS.CONTACT_US}#welcome`, '_blank')
                        }
                    />)}
                </div>

            )}
        </div>
    </div>);
};

export default FaqMobileView;